export const ERRORS = {
    NETWORK_ERROR: 'NetworkError',
    NS_BINDING_ABORTED: 'NS_BINDING_ABORTED',
};
export const PANEL_CODE_OVERRIDE = 'panel-code-override';
export const META_SITE_APP_DEF_ID = '22bef345-3c5b-4c18-b782-74d4085112ff';
export const WIX_APIS = 'https://www.wixapis.com';
//# sourceMappingURL=constants.js.map